/*
 * @Author: Src
 * @Date: 2025-06-30 16:53:28
 * @LastEditTime: 2025-08-12 23:31:55
 * @LastEditors: Src
 * @FilePath: /work-station/src/config/config.production.ts
 * @Description: 头部注释配置模板
 */
export default {
  API_URL: 'https://api.deyouhui.com.cn',
  RBAC_URL: 'https://rbac.deyouhui.com.cn',
  AUDIT_URL: 'https://audit.deyouhui.com.cn',
  CAR_URL: 'https://api.deyouhui.com.cn',

};
